var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"label":"Status","loading":_vm.loading},on:{"change":function($event){return _vm.save(_vm.memberpromo.status)}},model:{value:(_vm.memberpromo.status),callback:function ($$v) {_vm.$set(_vm.memberpromo, "status", $$v)},expression:"memberpromo.status"}})
}
var staticRenderFns = []

export { render, staticRenderFns }